<ng-template #valueTrigger let-popover>
  @if (valueLabel(); as label) {
    <button
      type="button"
      [attr.data-id]="dataIdPrefix() + '-value-trigger'"
      class="bd-value-editor__trigger"
      [disabled]="disabled()"
      (click)="popover.toggle($event, hostElement)"
    >
      @if (label.icon) {
        <i
          [attr.data-id]="dataIdPrefix() + '-value-icon'"
          class="{{ label.icon }}"
          aria-hidden="true"
        ></i>
      }
      <span>{{ (label | translateDisplayText: 'text' | async) ?? '' }}</span>
      <i class="ui-down" aria-hidden="true"></i>
    </button>
  }
</ng-template>

@let editor = descriptor();
@switch (editor.kind) {
  @case ('dropdown') {
    <bd-dropdown
      [attr.data-id]="dropdownDataId(editor.dropdownKind)"
      [options]="editor.options"
      [singleSelection]="editor.selected"
      [settings]="dropdownSettings()"
      [state]="disabled() ? 'disabled' : 'default'"
      [loading]="optionsLoading()"
      [positioningReferenceElement]="hostElement"
      (filter)="filterOptions.emit($event)"
      (selectNode)="selectNode.emit($event)"
    />
  }
  @case ('attribute') {
    <ng-container
      *ngTemplateOutlet="valueTrigger; context: { $implicit: attributePopover }"
    />
    <p-popover
      #attributePopover
      [attr.data-id]="dataIdPrefix() + '-attribute-popover'"
      [styleClass]="attributePopoverStyleClass()"
      (onShow)="startEditing(attributePopover)"
      (onHide)="stopEditing(); clearReferenceObjectSearch()"
    >
      @if (editingValue()) {
        @if (editor.payload; as payload) {
          @if (payload.type === 'reference') {
            <bd-object-search-panel
              [dataIdPrefix]="dataIdPrefix() + '-reference'"
              [objectTypeLabel]="referenceTypeLabel()"
              [searchSuggestions]="objectSuggestions()"
              [searchSuggestionsLoading]="objectSuggestionsLoading()"
              [disabled]="disabled()"
              (searchTermChanged)="onReferenceSearch($event)"
              (selectObject)="
                onReferenceObjectChange(payload, $event);
                attributePopover.hide()
              "
            />
          } @else {
            <bd-attribute-editor
              [attr.data-id]="dataIdPrefix() + '-attribute-editor'"
              [attribute]="payload"
              [attributeCategoryDefinitions]="attributeCategoryDefinitions()"
              [alwaysInEditMode]="true"
              [autoFocus]="true"
              [disabled]="disabled()"
              (keydown.enter)="commitValueEdit($event)"
              (updateAttribute)="
                onAttributeChange($event); attributePopover.hide()
              "
            />
          }
        }
      }
    </p-popover>
  }
  @case ('object') {
    <ng-container
      *ngTemplateOutlet="valueTrigger; context: { $implicit: objectPopover }"
    />
    <p-popover
      #objectPopover
      [attr.data-id]="dataIdPrefix() + '-relation-object-popover'"
      [styleClass]="panelStyleClass"
      (onShow)="startEditing(objectPopover)"
      (onHide)="stopEditing(); clearObjectSearch()"
    >
      @if (editingValue()) {
        <bd-object-search-panel
          [dataIdPrefix]="dataIdPrefix() + '-relation-object'"
          [searchSuggestions]="objectSuggestions()"
          [searchSuggestionsLoading]="objectSuggestionsLoading()"
          [disabled]="disabled()"
          (searchTermChanged)="onObjectSearch($event)"
          (selectObject)="onObjectChange($event); objectPopover.hide()"
        />
      }
    </p-popover>
  }
  @case ('text') {
    <ng-container
      *ngTemplateOutlet="valueTrigger; context: { $implicit: textPopover }"
    />
    <p-popover
      #textPopover
      [attr.data-id]="dataIdPrefix() + '-text-popover'"
      [styleClass]="panelStyleClass"
      (onShow)="startEditing(textPopover)"
      (onHide)="stopEditing()"
    >
      @if (editingValue()) {
        <input
          #textInput
          type="text"
          pInputText
          [attr.data-id]="dataIdPrefix() + '-text-input'"
          class="bd-value-editor__text-input"
          [attr.aria-label]="textInputAriaLabel()"
          [value]="editor.value"
          [disabled]="disabled()"
          [pAutoFocus]="true"
          (keydown.enter)="commitValueEdit($event)"
          (blur)="
            onTextChange(textInput.value, editor.value); textPopover.hide()
          "
        />
      }
    </p-popover>
  }
}
